import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger'
import counterReducer from '../features/counter/counterSlice';
import sessionReducer from '../features/session/sessionSlice';
import siteReducer from '../features/site/siteSlice';
import metricReducer from '../features/metric/metricSlice';

const settings = {
  serializableCheck: false
}

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    session: sessionReducer,
    site: siteReducer,
    metric: metricReducer,
  },
  middleware: (getDefaultMiddleware) => import.meta.env.MODE !== "production" ? getDefaultMiddleware(settings).concat(logger) : getDefaultMiddleware(settings)
});
